import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ListSellersParams, SellerConfirmedSemaphore } from 'src/app/core/sellers.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-sellers-filter-dialog',
  templateUrl: './sellers-filter-dialog.component.html',
  styleUrls: ['./sellers-filter-dialog.component.scss'],
})
export class SellersFilterDialogComponent {
  sellers_filter_from_group: FormGroup = this.form_service.sellers_filter_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  green: SellerConfirmedSemaphore = SellerConfirmedSemaphore.green;
  orange: SellerConfirmedSemaphore = SellerConfirmedSemaphore.orange;
  red: SellerConfirmedSemaphore = SellerConfirmedSemaphore.red;

  constructor(
    private dialog_ref: MatDialogRef<SellersFilterDialogComponent>,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const seller_id: string | '' = this.sellers_filter_from_group.get(this.form_service.seller_id_label)?.value;
      const seller_name: string | '' = this.sellers_filter_from_group.get(this.form_service.seller_name_label)?.value;
      const phone_value: string | '' = this.sellers_filter_from_group.get(this.form_service.phone_value_label)?.value;
      const email: string | '' = this.sellers_filter_from_group.get(this.form_service.email_label)?.value;
      const is_confirmed: string | '' = this.sellers_filter_from_group.get(this.form_service.is_confirmed_label)?.value;

      const params: ListSellersParams = {
        seller_id: seller_id == '' ? undefined : seller_id,
        seller_name: seller_name == '' ? undefined : seller_name,
        phone_value: phone_value == '' ? undefined : phone_value,
        email: email == '' ? undefined : email,
        is_confirmed: is_confirmed == '' ? undefined : is_confirmed,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.sellers_filter_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.sellers_filter_from_group);
  }
}
